//导入request.js
import http from "@/utils/request";//@==>src
//查询实验共享指数排行榜接口
export function getExpgongxiang() {
    return http({
        url: "/teaching/experiment/shareGetInfoList",
        method: "get",
    })
}
//查询实验互动指数排行榜接口
export function getExphudong() {
    return http({
        url: "/teaching/experiment/interactionCountGetInfoList",
        method: "get",
    })
}
//查询实验浏览指数排行榜接口
export function getExpliulan() {
    return http({
        url: "/teaching/experiment/browseNumGetInfoList",
        method: "get",
    })
}
//查询实验收藏指数排行榜接口
export function getExpshoucang() {
    return http({
        url: "/teaching/experiment/collectCountGetInfoList",
        method: "get",
    })
}


//查询课程共享指数排行榜接口
export function getCoursegongxiang() {
    return http({
        url: "/teaching/myCourse/shareGetInfoList",
        method: "get",
    })
}
//查询课程互动指数排行榜接口
export function getCoursehudong() {
    return http({
        url: "/teaching/myCourse/interactionCountGetInfoList",
        method: "get",
    })
}
//查询课程浏览指数排行榜接口
export function getCourseliulan() {
    return http({
        url: "/teaching/myCourse/browseNumGetInfoList",
        method: "get",
    })
}
//查询课程收藏指数排行榜接口
export function getCourseshoucang() {
    return http({
        url: "/teaching/myCourse/collectCountGetInfoList",
        method: "get",
    })
}
